// src/pages/auth/Login.js
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { Avatar, message, Spin } from "antd";
import { GoogleLogin } from "@react-oauth/google";
import { loginSuccess } from "../../redux/slices/userSlice";
import LOGO from "../../assets/fastest-logo.jpg.png";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { fetchCustomers } from "../../components/customer/FetchCustomers";
import { googleAuth } from "../../endpoints/API";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const [customers, setCustomers] = useState([]);

  const handleLogin = async (credentialResponse) => {
    const googleToken = credentialResponse.credential;

    try {
      const res = await googleAuth(googleToken);
      const data = await res?.data;

      if (res.statusText="OK") {
        // localStorage.setItem("access_token", data.access);
        dispatch(
          loginSuccess({
            user: data.admin || {},
            token: data.access,
          })
        );

        message.success("Login successful!");
        // window.location.reload();
        navigate("/home");
      } else {
        message.error(`Login failed: ${data.detail || "Unknown error"}`);
      }
    } catch (error) {
      message.error(error?.response?.data?.detail||"Login error. Please try again.");
    }
  };

  return (
    <Spin spinning={false}>
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center border p-4 rounded-lg shadow-md">
          <Link to="/">
            <Avatar
              shape="square"
              src={LOGO}
              style={{ width: "400px", height: "100px" }}
            />
          </Link>
          <div className="mt-[.5rem] text-gray-500">
            Welcome Admin - Sign In With Google
          </div>
          <div style={{ marginTop: "1rem" }}>
            <GoogleLogin
              onSuccess={handleLogin}
              onError={() => message.error("Google Login Failed")}
            />
          </div>
          <div className="mt-4">
            <Link
              to="/forgotpassword"
              className="text-blue-500 hover:underline"
            >
              Forgot Password?
            </Link>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default Login;
